import PropTypes from 'prop-types';

const FacetButton = ({ facet, context }) => {
  const classNames = () => {
    const classes = ['btn', 'btn-xs', 'btn-default', 'clickable'];
    if (facet.disabled) classes.push('disabled');
    if (facet.active) classes.push('active');

    return classes.join(' ');
  };

  const handleClick = () => {
    if (facet.disabled) return;

    context.executeAction(window.LP.module('Searches').SearchActions.toggleFacet, {
      facet
    });
  };

  const title = () => {
    if (facet.key === 'grade_ids' && facet.title.match(/^\d/)) {
      return parseInt(facet.title, 10);
    }

    if (facet.key === 'grade_ids' && facet.title === 'Kindergarten') {
      return 'K';
    }

    return facet.title;
  };

  return (
    <li className={classNames()} onClick={handleClick}>
      {title()}
    </li>
  );
};

FacetButton.propTypes = {
  facet: PropTypes.object,
  context: PropTypes.object
};

export default FacetButton;
